import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<object>;

export default function TFoot({ children }: Props) {
  const styles: CSSProperties = {
    border: "1px solid var(--color-border-primary)",
    borderRadius: "var(--border-radius-lg)",
    backgroundColor: "var(--color-background-elevated)",
  };

  return <tfoot style={styles}>{children}</tfoot>;
}
